import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearLeftSidePanelInteriorProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function RearLeftSidePanelInterior(props: RearLeftSidePanelInteriorProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Rear Left Side Panel"
      width={275}
      height={43}
      viewBox="0 0 275 43"
      position={{right: 107, bottom: 0}}
    >
      <path
        d="M274 0.997887C266.083 2.63604 248.95 11.4984 234 17.9988C211 27.9993 170 40.9999 148 42L0 41.9999C27 41.9999 60 31 60 13C60 11.2514 59.637 9.5887 58.9406 8C162.893 8 253.5 5.23946 274 0.997887Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M148 42C170 40.9999 211 27.9993 234 17.9988C248.95 11.4984 266.083 2.63604 274 0.997887C249.2 6.1962 120.294 7.83192 58.9406 8C59.637 9.5887 60 11.2514 60 13C60 31 27 41.9999 0 41.9999C67.5607 41.9999 80.4393 42 148 42ZM148 42L150 41.9999"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M59 18.3044C152.031 16.8281 226 14.1305 247 12.0435"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
